module.exports = "https://images.shiksha.ws/saassets/media/Success_BgImage.16d30e28.png";